import { Flex } from '@/components/common';
import { Locales } from '@/configs';
import { useLocaleStore } from '@/store';
import { Popover } from 'antd';
import classNames from 'classnames';
import { useCallback, useMemo } from 'react';
import { IcArrow } from '@/components/common/IcArrow';

// Import flag SVGs as React components
import { ReactComponent as IranFlag } from '@/assets/images/flags/ir.svg';
import { ReactComponent as UKFlag } from '@/assets/images/flags/gb.svg';
import { ReactComponent as SaudiFlag } from '@/assets/images/flags/sa.svg';

import './LocaleButton.css';

const items = [
  { key: Locales.Persian, title: 'فارسی', Flag: IranFlag },
  { key: Locales.English, title: 'English', Flag: UKFlag },
  { key: Locales.Arabic, title: 'العربية', Flag: SaudiFlag },
];

export interface LocaleButtonProps {
  className?: string;
}

export function LocaleButton({
  className = undefined
}: LocaleButtonProps) {

  const [locale, setLocale] = useLocaleStore(state => [state.locale, state.setLocale]);

  const onChangeLocale = useCallback((key => {
    setLocale(key);
    window.location.reload();
  }), [setLocale]);

  const renderedItems = useMemo(() => (
    <Flex gap={0} direction="column" className="locale-menu">
      {items.map(item => {
        const FlagComponent = item.Flag;
        return (
          <div
            key={item.key}
            onClick={() => onChangeLocale(item.key)}
            className={classNames('locale-item', { active: item.key === locale })}
          >
            <Flex align="center" gap={8}>
              <FlagComponent style={{ width: '20px', height: '15px' }} />
              {item.title}
            </Flex>
          </div>
        );
      })}
    </Flex>
  ), [locale, onChangeLocale]);

  const CurrentFlagComponent = items.find(item => item.key === locale)?.Flag || items[0].Flag;

  return (
    <Popover
      trigger={['hover']}
      placement="bottom"
      content={renderedItems}
      rootClassName="locale-menu-root"
    >
      <Flex inlineFlex align="center" justify="center" gap={4} className="locale-trigger">
        <IcArrow type="down" size={8} className="locale-arrow" />
        <CurrentFlagComponent
          className={classNames('locale-icon', className)}
          style={{ width: '24px', height: '18px' }}
        />
      </Flex>
    </Popover>
  );
}

export default LocaleButton;
